const ipaddress = window.location.hostname;
const isLocal = ipaddress === 'localhost' || ipaddress === '127.0.0.1';

// 1. Endpoint principal para las peticiones a api.php
export const API_URL = isLocal
  ? 'http://localhost:9000/api.php'
  : `${window.location.protocol}//${ipaddress}/api.php`;

// 2. URL Base para cargar imágenes
export const BASE_URL = isLocal
  ? 'http://localhost:9000'
  : `${window.location.protocol}//${ipaddress}`;

// 3. Exportaciones para compatibilidad legacy
const port = isLocal ? '9000' : '';

export { ipaddress, port, isLocal };